function getRangeTableMock() {
  return [
    {
      id: 'AA',
      s: 'background-image: linear-gradient(to right, var(--clr-R4-initial), var(--clr-R4-initial)),linear-gradient(to right, var(--clr-R3-initial), var(--clr-R3-initial)),linear-gradient(to right, var(--clr-R2-initial), var(--clr-R2-initial)),linear-gradient(to right, var(--clr-X), var(--clr-X)); background-size:58.650001883516666% 100%,92.48333623013333% 100%,99.416669985915% 100%,100.00000333725282% 100%;',
    },
    {
      id: 'AKs',
      s: 'background-image: linear-gradient(to right, var(--clr-R4-initial), var(--clr-R4-initial)),linear-gradient(to right, var(--clr-R3-initial), var(--clr-R3-initial)),linear-gradient(to right, var(--clr-R2-initial), var(--clr-R2-initial)),linear-gradient(to right, var(--clr-X), var(--clr-X)); background-size:18.500000983465% 100%,44.40000206234% 100%,72.42500390859% 100%,100.0000046071775% 100%;',
    },
    {
      id: 'AQs',
      s: 'background-image: linear-gradient(to right, var(--clr-R4-initial), var(--clr-R4-initial)),linear-gradient(to right, var(--clr-R3-initial), var(--clr-R3-initial)),linear-gradient(to right, var(--clr-R2-initial), var(--clr-R2-initial)),linear-gradient(to right, var(--clr-X), var(--clr-X)); background-size:54.5000016689% 100%,80.36666909853334% 100%,99.30000305176667% 100%,100.00000306949266% 100%;',
    },
    {
      id: 'AJs',
      s: 'background-image: linear-gradient(to right, var(--clr-R4-initial), var(--clr-R4-initial)),linear-gradient(to right, var(--clr-R3-initial), var(--clr-R3-initial)),linear-gradient(to right, var(--clr-R2-initial), var(--clr-R2-initial)),linear-gradient(to right, var(--clr-X), var(--clr-X)); background-size:24.375000968600002% 100%,49.600001424575% 100%,66.90000221135% 100%,100.0000031082975% 100%;',
    },
    {
      id: 'ATs',
      s: 'background-image: linear-gradient(to right, var(--clr-R4-initial), var(--clr-R4-initial)),linear-gradient(to right, var(--clr-R3-initial), var(--clr-R3-initial)),linear-gradient(to right, var(--clr-R2-initial), var(--clr-R2-initial)),linear-gradient(to right, var(--clr-X), var(--clr-X)); background-size:5.73333352804% 100%,32.266667981939996% 100%,55.90000202257333% 100%,100.00000347694001% 100%;',
    },
    {
      id: 'A9s',
      s: 'background-image: linear-gradient(to right, var(--clr-R4-initial), var(--clr-R4-initial)),linear-gradient(to right, var(--clr-R3-initial), var(--clr-R3-initial)),linear-gradient(to right, var(--clr-R2-initial), var(--clr-R2-initial)),linear-gradient(to right, var(--clr-X), var(--clr-X)); background-size:6.550000212149251% 100%,22.12500066962425% 100%,41.1250009201515% 100%,100.0000028870765% 100%;',
    },
    {
      id: 'A8s',
      s: 'background-image: linear-gradient(to right, var(--clr-R4-initial), var(--clr-R4-initial)),linear-gradient(to right, var(--clr-R3-initial), var(--clr-R3-initial)),linear-gradient(to right, var(--clr-R2-initial), var(--clr-R2-initial)),linear-gradient(to right, var(--clr-X), var(--clr-X)); background-size:11.42500070854675% 100%,18.900000897698753% 100%,34.80000145499875% 100%,100.00000394647374% 100%;',
    },
    {
      id: 'A7s',
      s: 'background-image: linear-gradient(to right, var(--clr-R4-initial), var(--clr-R4-initial)),linear-gradient(to right, var(--clr-R3-initial), var(--clr-R3-initial)),linear-gradient(to right, var(--clr-R2-initial), var(--clr-R2-initial)),linear-gradient(to right, var(--clr-X), var(--clr-X)); background-size:14.43333377442% 100%,25.06666716655333% 100%,45.400000976719994% 100%,100.00000309665333% 100%;',
    },
    {
      id: 'A6s',
      s: 'background-image: linear-gradient(to right, var(--clr-R4-initial), var(--clr-R4-initial)),linear-gradient(to right, var(--clr-R3-initial), var(--clr-R3-initial)),linear-gradient(to right, var(--clr-R2-initial), var(--clr-R2-initial)),linear-gradient(to right, var(--clr-X), var(--clr-X)); background-size:14.500000607224997% 100%,32.450001593675% 100%,53.250003140424994% 100%,100.000006984925% 100%;',
    },
    {
      id: 'A5s',
      s: 'background-image: linear-gradient(to right, var(--clr-R4-initial), var(--clr-R4-initial)),linear-gradient(to right, var(--clr-R3-initial), var(--clr-R3-initial)),linear-gradient(to right, var(--clr-R2-initial), var(--clr-R2-initial)),linear-gradient(to right, var(--clr-X), var(--clr-X)); background-size:21.325000934325% 100%,44.875002093625% 100%,50.300002330935% 100%,100.00000414441999% 100%;',
    },
    {
      id: 'A4s',
      s: 'background-image: linear-gradient(to right, var(--clr-R4-initial), var(--clr-R4-initial)),linear-gradient(to right, var(--clr-R3-initial), var(--clr-R3-initial)),linear-gradient(to right, var(--clr-R2-initial), var(--clr-R2-initial)),linear-gradient(to right, var(--clr-X), var(--clr-X)); background-size:29.1250012815% 100%,57.80000276865% 100%,67.2750030644375% 100%,100.0000040046925% 100%;',
    },
    {
      id: 'A3s',
      s: 'background-image: linear-gradient(to right, var(--clr-R4-initial), var(--clr-R4-initial)),linear-gradient(to right, var(--clr-R3-initial), var(--clr-R3-initial)),linear-gradient(to right, var(--clr-R2-initial), var(--clr-R2-initial)),linear-gradient(to right, var(--clr-X), var(--clr-X)); background-size:36.500001698725% 100%,62.625002861024996% 100%,72.82500327561999% 100%,100.00000470316999% 100%;',
    },
    {
      id: 'A2s',
      s: 'background-image: linear-gradient(to right, var(--clr-R4-initial), var(--clr-R4-initial)),linear-gradient(to right, var(--clr-R3-initial), var(--clr-R3-initial)),linear-gradient(to right, var(--clr-R2-initial), var(--clr-R2-initial)),linear-gradient(to right, var(--clr-X), var(--clr-X)); background-size:40.025001764275% 100%,72.2000032663% 100%,84.000003430965% 100%,100.00000419091499% 100%;',
    },
    {
      id: 'AKo',
      s: 'background-image: linear-gradient(to right, var(--clr-R4-initial), var(--clr-R4-initial)),linear-gradient(to right, var(--clr-R3-initial), var(--clr-R3-initial)),linear-gradient(to right, var(--clr-R2-initial), var(--clr-R2-initial)),linear-gradient(to right, var(--clr-X), var(--clr-X)); background-size:18.533334011828337% 100%,41.866668437920005% 100%,61.90000300606667% 100%,100.00000521543333% 100%;',
    },
    {
      id: 'KK',
      s: 'background-image: linear-gradient(to right, var(--clr-R4-initial), var(--clr-R4-initial)),linear-gradient(to right, var(--clr-R3-initial), var(--clr-R3-initial)),linear-gradient(to right, var(--clr-R2-initial), var(--clr-R2-initial)),linear-gradient(to right, var(--clr-X), var(--clr-X)); background-size:61.65000200271666% 100%,96.25000407298333% 100%,99.95000427588799% 100%,100.00000427826299% 100%;',
    },
    {
      id: 'KQs',
      s: 'background-image: linear-gradient(to right, var(--clr-R4-initial), var(--clr-R4-initial)),linear-gradient(to right, var(--clr-R3-initial), var(--clr-R3-initial)),linear-gradient(to right, var(--clr-R2-initial), var(--clr-R2-initial)),linear-gradient(to right, var(--clr-X), var(--clr-X)); background-size:49.66666897136667% 100%,82.36666917803333% 100%,95.30000314118666% 100%,100.00000316263666% 100%;',
    },
    {
      id: 'KJs',
      s: 'background-image: linear-gradient(to right, var(--clr-R4-initial), var(--clr-R4-initial)),linear-gradient(to right, var(--clr-R3-initial), var(--clr-R3-initial)),linear-gradient(to right, var(--clr-R2-initial), var(--clr-R2-initial)),linear-gradient(to right, var(--clr-X), var(--clr-X)); background-size:30.975001305325% 100%,59.37500223515% 100%,87.450003623925% 100%,100.000004470325% 100%;',
    },
    {
      id: 'KTs',
      s: 'background-image: linear-gradient(to right, var(--clr-R4-initial), var(--clr-R4-initial)),linear-gradient(to right, var(--clr-R3-initial), var(--clr-R3-initial)),linear-gradient(to right, var(--clr-R2-initial), var(--clr-R2-initial)),linear-gradient(to right, var(--clr-X), var(--clr-X)); background-size:0.133333339666% 100%,23.433334364866% 100%,50.70000165139933% 100%,100.000004703166% 100%;',
    },
    {
      id: 'K9s',
      s: 'background-image: linear-gradient(to right, var(--clr-R4-initial), var(--clr-R4-initial)),linear-gradient(to right, var(--clr-R3-initial), var(--clr-R3-initial)),linear-gradient(to right, var(--clr-R2-initial), var(--clr-R2-initial)),linear-gradient(to right, var(--clr-X), var(--clr-X)); background-size:39.675002545125% 100%,75.875005126025% 100%,87.2250054031775% 100%,100.00000614675251% 100%;',
    },
    {
      id: 'K8s',
      s: 'background-image: linear-gradient(to right, var(--clr-R4-initial), var(--clr-R4-initial)),linear-gradient(to right, var(--clr-R3-initial), var(--clr-R3-initial)),linear-gradient(to right, var(--clr-R2-initial), var(--clr-R2-initial)),linear-gradient(to right, var(--clr-X), var(--clr-X)); background-size:11.5250006783785% 100%,30.150001915178503% 100%,56.350002856928505% 100%,100.00000637957851% 100%;',
    },
    {
      id: 'K7s',
      s: 'background-image: linear-gradient(to right, var(--clr-R4-initial), var(--clr-R4-initial)),linear-gradient(to right, var(--clr-R3-initial), var(--clr-R3-initial)),linear-gradient(to right, var(--clr-R2-initial), var(--clr-R2-initial)),linear-gradient(to right, var(--clr-X), var(--clr-X)); background-size:31.200000643733333% 100%,40.200001063437995% 100%,50.366668465211326% 100%,100.00000297632799% 100%;',
    },
    {
      id: 'K6s',
      s: 'background-image: linear-gradient(to right, var(--clr-R4-initial), var(--clr-R4-initial)),linear-gradient(to right, var(--clr-R3-initial), var(--clr-R3-initial)),linear-gradient(to right, var(--clr-R2-initial), var(--clr-R2-initial)),linear-gradient(to right, var(--clr-X), var(--clr-X)); background-size:17.375000799094504% 100%,30.750001454729507% 100%,53.00000221467951% 100%,100.00000526200452% 100%;',
    },
    {
      id: 'K5s',
      s: 'background-image: linear-gradient(to right, var(--clr-R4-initial), var(--clr-R4-initial)),linear-gradient(to right, var(--clr-R3-initial), var(--clr-R3-initial)),linear-gradient(to right, var(--clr-R2-initial), var(--clr-R2-initial)),linear-gradient(to right, var(--clr-X), var(--clr-X)); background-size:24.100000783805005% 100%,44.62500177323001% 100%,60.42500305920001% 100%,100.0000055879% 100%;',
    },
    {
      id: 'K4s',
      s: 'background-image: linear-gradient(to right, var(--clr-R4-initial), var(--clr-R4-initial)),linear-gradient(to right, var(--clr-R3-initial), var(--clr-R3-initial)),linear-gradient(to right, var(--clr-R1-initial), var(--clr-R1-initial)),linear-gradient(to right, var(--clr-X), var(--clr-X)); background-size:23.825001344100002% 100%,48.475002870000004% 100%,66.525003314055% 100%,100.000004470405% 100%;',
    },
    {
      id: 'K3s',
      s: 'background-image: linear-gradient(to right, var(--clr-R4-initial), var(--clr-R4-initial)),linear-gradient(to right, var(--clr-R3-initial), var(--clr-R3-initial)),linear-gradient(to right, var(--clr-R1-initial), var(--clr-R1-initial)),linear-gradient(to right, var(--clr-X), var(--clr-X)); background-size:24.400001019224998% 100%,49.725002050375% 100%,66.5500029921425% 100%,100.0000052154175% 100%;',
    },
    {
      id: 'K2s',
      s: 'background-image: linear-gradient(to right, var(--clr-R4-initial), var(--clr-R4-initial)),linear-gradient(to right, var(--clr-R3-initial), var(--clr-R3-initial)),linear-gradient(to right, var(--clr-R1-initial), var(--clr-R1-initial)),linear-gradient(to right, var(--clr-X), var(--clr-X)); background-size:27.550001442425% 100%,58.150003105399996% 100%,75.82500372084249% 100%,100.00000502914249% 100%;',
    },
    {
      id: 'AQo',
      s: 'background-image: linear-gradient(to right, var(--clr-R4-initial), var(--clr-R4-initial)),linear-gradient(to right, var(--clr-R3-initial), var(--clr-R3-initial)),linear-gradient(to right, var(--clr-R1-initial), var(--clr-R1-initial)),linear-gradient(to right, var(--clr-X), var(--clr-X)); background-size:54.70000207422223% 100%,81.50000274181112% 100%,94.50000309282112% 100%,100.00000324928334% 100%;',
    },
    {
      id: 'KQo',
      s: 'background-image: linear-gradient(to right, var(--clr-R4-initial), var(--clr-R4-initial)),linear-gradient(to right, var(--clr-R3-initial), var(--clr-R3-initial)),linear-gradient(to right, var(--clr-R1-initial), var(--clr-R1-initial)),linear-gradient(to right, var(--clr-X), var(--clr-X)); background-size:43.16666821637778% 100%,71.98889156183333% 100%,86.45555873714444% 100%,100.00000380809111% 100%;',
    },
    {
      id: 'QQ',
      s: 'background-image: linear-gradient(to right, var(--clr-R4-initial), var(--clr-R4-initial)),linear-gradient(to right, var(--clr-R3-initial), var(--clr-R3-initial)),linear-gradient(to right, var(--clr-R1-initial), var(--clr-R1-initial)),linear-gradient(to right, var(--clr-X), var(--clr-X)); background-size:9.366666773956666% 100%,50.56666880849% 100%,99.43333715202334% 100%,100.00000383396268% 100%;',
    },
    {
      id: 'QJs',
      s: 'background-image: linear-gradient(to right, var(--clr-R4-initial), var(--clr-R4-initial)),linear-gradient(to right, var(--clr-R3-initial), var(--clr-R3-initial)),linear-gradient(to right, var(--clr-R1-initial), var(--clr-R1-initial)),linear-gradient(to right, var(--clr-X), var(--clr-X)); background-size:36.4333351453% 100%,75.8666694164% 100%,90.06666988133334% 100%,100.00000347693334% 100%;',
    },
    {
      id: 'QTs',
      s: 'background-image: linear-gradient(to right, var(--clr-R4-initial), var(--clr-R4-initial)),linear-gradient(to right, var(--clr-R3-initial), var(--clr-R3-initial)),linear-gradient(to right, var(--clr-R1-initial), var(--clr-R1-initial)),linear-gradient(to right, var(--clr-X), var(--clr-X)); background-size:47.80000050866667% 100%,88.96666963896668% 100%,99.73333676656668% 100%,100.00000344589935% 100%;',
    },
    {
      id: 'Q9s',
      s: 'background-image: linear-gradient(to right, var(--clr-R4-initial), var(--clr-R4-initial)),linear-gradient(to right, var(--clr-R3-initial), var(--clr-R3-initial)),linear-gradient(to right, var(--clr-R1-initial), var(--clr-R1-initial)),linear-gradient(to right, var(--clr-X), var(--clr-X)); background-size:16.533334056566666% 100%,49.5000024637% 100%,69.46667035423333% 100%,100.00000447036666% 100%;',
    },
    {
      id: 'Q8s',
      s: 'background-image: linear-gradient(to right, var(--clr-R4-initial), var(--clr-R4-initial)),linear-gradient(to right, var(--clr-R3-initial), var(--clr-R3-initial)),linear-gradient(to right, var(--clr-R1-initial), var(--clr-R1-initial)),linear-gradient(to right, var(--clr-X), var(--clr-X)); background-size:15.333333611533334% 100%,41.80000027023334% 100%,59.56666767603334% 100%,100.00000298033333% 100%;',
    },
    {
      id: 'Q7s',
      s: 'background-image: linear-gradient(to right, var(--clr-R4-initial), var(--clr-R4-initial)),linear-gradient(to right, var(--clr-R3-initial), var(--clr-R3-initial)),linear-gradient(to right, var(--clr-R1-initial), var(--clr-R1-initial)),linear-gradient(to right, var(--clr-X), var(--clr-X)); background-size:16.700001061% 100%,44.9000015855% 100%,74.2000028491% 100%,100.00000447030001% 100%;',
    },
    {
      id: 'Q6s',
      s: 'background-image: linear-gradient(to right, var(--clr-R4-initial), var(--clr-R4-initial)),linear-gradient(to right, var(--clr-R3-initial), var(--clr-R3-initial)),linear-gradient(to right, var(--clr-R1-initial), var(--clr-R1-initial)),linear-gradient(to right, var(--clr-X), var(--clr-X)); background-size:0.2666666793326667% 100%,14.600000251099335% 100%,37.36666785553267% 100%,100.00000543269934% 100%;',
    },
    {
      id: 'Q5s',
      s: 'background-image: linear-gradient(to right, var(--clr-R4-initial), var(--clr-R4-initial)),linear-gradient(to right, var(--clr-R3-initial), var(--clr-R3-initial)),linear-gradient(to right, var(--clr-R1-initial), var(--clr-R1-initial)),linear-gradient(to right, var(--clr-X), var(--clr-X)); background-size:0.46666667331% 100%,24.600001230543334% 100%,49.00000299481% 100%,100.00000402794333% 100%;',
    },
    {
      id: 'Q4s',
      s: 'background-image: linear-gradient(to right, var(--clr-R4-initial), var(--clr-R4-initial)),linear-gradient(to right, var(--clr-R3-initial), var(--clr-R3-initial)),linear-gradient(to right, var(--clr-R1-initial), var(--clr-R1-initial)),linear-gradient(to right, var(--clr-X), var(--clr-X)); background-size:0.033333334916666665% 100%,13.266667657683334% 100%,37.56666872258334% 100%,100.00000490108334% 100%;',
    },
    {
      id: 'Q3s',
      s: 'background-image: linear-gradient(to right, var(--clr-R4-initial), var(--clr-R4-initial)),linear-gradient(to right, var(--clr-R3-initial), var(--clr-R3-initial)),linear-gradient(to right, var(--clr-R1-initial), var(--clr-R1-initial)),linear-gradient(to right, var(--clr-X), var(--clr-X)); background-size:0.7666667302433334% 100%,7.466667145486666% 100%,33.166668067353335% 100%,100.00000322858665% 100%;',
    },
    {
      id: 'Q2s',
      s: 'background-image: linear-gradient(to right, var(--clr-R3-initial), var(--clr-R3-initial)),linear-gradient(to right, var(--clr-R1-initial), var(--clr-R1-initial)),linear-gradient(to right, var(--clr-X), var(--clr-X)); background-size:0.06666666983333333% 100%,7.200000303166666% 100%,100.00000359336667% 100%;',
    },
    {
      id: 'AJo',
      s: 'background-image: linear-gradient(to right, var(--clr-R4-initial), var(--clr-R4-initial)),linear-gradient(to right, var(--clr-R3-initial), var(--clr-R3-initial)),linear-gradient(to right, var(--clr-R1-initial), var(--clr-R1-initial)),linear-gradient(to right, var(--clr-X), var(--clr-X)); background-size:29.508334894975004% 100%,52.85000242293334% 100%,65.18333603936918% 100%,100.00000422198585% 100%;',
    },
    {
      id: 'KJo',
      s: 'background-image: linear-gradient(to right, var(--clr-R4-initial), var(--clr-R4-initial)),linear-gradient(to right, var(--clr-R3-initial), var(--clr-R3-initial)),linear-gradient(to right, var(--clr-R1-initial), var(--clr-R1-initial)),linear-gradient(to right, var(--clr-X), var(--clr-X)); background-size:27.208334455899998% 100%,55.58333545924167% 100%,75.56666992605% 100%,100.00000409780833% 100%;',
    },
    {
      id: 'QJo',
      s: 'background-image: linear-gradient(to right, var(--clr-R4-initial), var(--clr-R4-initial)),linear-gradient(to right, var(--clr-R3-initial), var(--clr-R3-initial)),linear-gradient(to right, var(--clr-R1-initial), var(--clr-R1-initial)),linear-gradient(to right, var(--clr-X), var(--clr-X)); background-size:30.244445966355553% 100%,64.1888924771% 100%,81.34444869227778% 100%,100.00000546374444% 100%;',
    },
    {
      id: 'JJ',
      s: 'background-image: linear-gradient(to right, var(--clr-R4-initial), var(--clr-R4-initial)),linear-gradient(to right, var(--clr-R3-initial), var(--clr-R3-initial)),linear-gradient(to right, var(--clr-R1-initial), var(--clr-R1-initial)),linear-gradient(to right, var(--clr-X), var(--clr-X)); background-size:2.4333334217466667% 100%,14.71666706104667% 100%,45.166668916763335% 100%,100.00000459453% 100%;',
    },
    {
      id: 'JTs',
      s: 'background-image: linear-gradient(to right, var(--clr-R4-initial), var(--clr-R4-initial)),linear-gradient(to right, var(--clr-R3-initial), var(--clr-R3-initial)),linear-gradient(to right, var(--clr-R1-initial), var(--clr-R1-initial)),linear-gradient(to right, var(--clr-X), var(--clr-X)); background-size:3.300000106296667% 100%,15.733334546313333% 100%,41.00000274681334% 100%,100.00000608464669% 100%;',
    },
    {
      id: 'J9s',
      s: 'background-image: linear-gradient(to right, var(--clr-R4-initial), var(--clr-R4-initial)),linear-gradient(to right, var(--clr-R3-initial), var(--clr-R3-initial)),linear-gradient(to right, var(--clr-R1-initial), var(--clr-R1-initial)),linear-gradient(to right, var(--clr-X), var(--clr-X)); background-size:28.125001490125% 100%,56.375003606099995% 100%,86.550004780325% 100%,100.00000516596249% 100%;',
    },
    {
      id: 'J8s',
      s: 'background-image: linear-gradient(to right, var(--clr-R4-initial), var(--clr-R4-initial)),linear-gradient(to right, var(--clr-R3-initial), var(--clr-R3-initial)),linear-gradient(to right, var(--clr-R1-initial), var(--clr-R1-initial)),linear-gradient(to right, var(--clr-X), var(--clr-X)); background-size:30.700001120599996% 100%,63.325003534575% 100%,73.900003917535% 100%,100.000005029185% 100%;',
    },
    {
      id: 'J7s',
      s: 'background-image: linear-gradient(to right, var(--clr-R4-initial), var(--clr-R4-initial)),linear-gradient(to right, var(--clr-R3-initial), var(--clr-R3-initial)),linear-gradient(to right, var(--clr-R1-initial), var(--clr-R1-initial)),linear-gradient(to right, var(--clr-X), var(--clr-X)); background-size:14.000000897793335% 100%,22.866667651893337% 100%,40.433335149026675% 100%,100.00000481179335% 100%;',
    },
    {
      id: 'J6s',
      s: 'background-image: linear-gradient(to right, var(--clr-R4-initial), var(--clr-R4-initial)),linear-gradient(to right, var(--clr-R3-initial), var(--clr-R3-initial)),linear-gradient(to right, var(--clr-R1-initial), var(--clr-R1-initial)),linear-gradient(to right, var(--clr-X), var(--clr-X)); background-size:12.60000085458% 100%,27.725002076475% 100%,61.225002910925% 100%,100.00000512225% 100%;',
    },
    {
      id: 'J5s',
      s: 'background-image: linear-gradient(to right, var(--clr-R4-initial), var(--clr-R4-initial)),linear-gradient(to right, var(--clr-R3-initial), var(--clr-R3-initial)),linear-gradient(to right, var(--clr-R1-initial), var(--clr-R1-initial)),linear-gradient(to right, var(--clr-X), var(--clr-X)); background-size:17.500000447050002% 100%,44.6000017226% 100%,67.1750035137% 100%,100.00000484284999% 100%;',
    },
    {
      id: 'J4s',
      s: 'background-image: linear-gradient(to right, var(--clr-R4-initial), var(--clr-R4-initial)),linear-gradient(to right, var(--clr-R3-initial), var(--clr-R3-initial)),linear-gradient(to right, var(--clr-R1-initial), var(--clr-R1-initial)),linear-gradient(to right, var(--clr-X), var(--clr-X)); background-size:16.650000866475% 100%,43.275002296974996% 100%,67.275003623175% 100%,100.00000512225% 100%;',
    },
    {
      id: 'J3s',
      s: '',
    },
    {
      id: 'J2s',
      s: '',
    },
    {
      id: 'ATo',
      s: 'background-image: linear-gradient(to right, var(--clr-R4-initial), var(--clr-R4-initial)),linear-gradient(to right, var(--clr-R3-initial), var(--clr-R3-initial)),linear-gradient(to right, var(--clr-R1-initial), var(--clr-R1-initial)),linear-gradient(to right, var(--clr-X), var(--clr-X)); background-size:8.488889286903332% 100%,43.12222475804777% 100%,60.9111142654811% 100%,100.00000521538111% 100%;',
    },
    {
      id: 'KTo',
      s: 'background-image: linear-gradient(to right, var(--clr-R4-initial), var(--clr-R4-initial)),linear-gradient(to right, var(--clr-R3-initial), var(--clr-R3-initial)),linear-gradient(to right, var(--clr-R1-initial), var(--clr-R1-initial)),linear-gradient(to right, var(--clr-X), var(--clr-X)); background-size:0.2777777909715557% 100%,17.622223112282665% 100%,43.822223888471555% 100%,100.000005576316% 100%;',
    },
    {
      id: 'QTo',
      s: 'background-image: linear-gradient(to right, var(--clr-R4-initial), var(--clr-R4-initial)),linear-gradient(to right, var(--clr-R3-initial), var(--clr-R3-initial)),linear-gradient(to right, var(--clr-R1-initial), var(--clr-R1-initial)),linear-gradient(to right, var(--clr-X), var(--clr-X)); background-size:50.13333459693333% 100%,91.83333615456667% 100%,99.83333672081% 100%,100.00000339151266% 100%;',
    },
    {
      id: 'JTo',
      s: 'background-image: linear-gradient(to right, var(--clr-R4-initial), var(--clr-R4-initial)),linear-gradient(to right, var(--clr-R3-initial), var(--clr-R3-initial)),linear-gradient(to right, var(--clr-R1-initial), var(--clr-R1-initial)),linear-gradient(to right, var(--clr-X), var(--clr-X)); background-size:1.2111111272448891% 100%,9.555556090913779% 100%,34.07777966282489% 100%,100.00000418445822% 100%;',
    },
    {
      id: 'TT',
      s: 'background-image: linear-gradient(to right, var(--clr-R4-initial), var(--clr-R4-initial)),linear-gradient(to right, var(--clr-R3-initial), var(--clr-R3-initial)),linear-gradient(to right, var(--clr-R1-initial), var(--clr-R1-initial)); background-size:34.300001462299996% 100%,59.400002161633324% 100%,100.00000397363333% 100%;',
    },
    {
      id: 'T9s',
      s: 'background-image: linear-gradient(to right, var(--clr-R4-initial), var(--clr-R4-initial)),linear-gradient(to right, var(--clr-R3-initial), var(--clr-R3-initial)),linear-gradient(to right, var(--clr-R1-initial), var(--clr-R1-initial)),linear-gradient(to right, var(--clr-X), var(--clr-X)); background-size:7.966667041179999% 100%,25.03333451844667% 100%,56.13333644961334% 100%,100.00000459444666% 100%;',
    },
    {
      id: 'T8s',
      s: 'background-image: linear-gradient(to right, var(--clr-R4-initial), var(--clr-R4-initial)),linear-gradient(to right, var(--clr-R3-initial), var(--clr-R3-initial)),linear-gradient(to right, var(--clr-R1-initial), var(--clr-R1-initial)),linear-gradient(to right, var(--clr-X), var(--clr-X)); background-size:15.000001092759998% 100%,24.033334602926665% 100%,51.733336100993334% 100%,100.00000521542665% 100%;',
    },
    {
      id: 'T7s',
      s: 'background-image: linear-gradient(to right, var(--clr-R4-initial), var(--clr-R4-initial)),linear-gradient(to right, var(--clr-R3-initial), var(--clr-R3-initial)),linear-gradient(to right, var(--clr-R1-initial), var(--clr-R1-initial)),linear-gradient(to right, var(--clr-X), var(--clr-X)); background-size:41.1000013351% 100%,84.7000032663% 100%,99.800004065% 100%,100.000004074499% 100%;',
    },
    {
      id: 'T6s',
      s: 'background-image: linear-gradient(to right, var(--clr-R4-initial), var(--clr-R4-initial)),linear-gradient(to right, var(--clr-R3-initial), var(--clr-R3-initial)),linear-gradient(to right, var(--clr-R1-initial), var(--clr-R1-initial)),linear-gradient(to right, var(--clr-X), var(--clr-X)); background-size:8.466667123143335% 100%,8.533333792976334% 100%,38.966668699843% 100%,100.00000502134299% 100%;',
    },
    {
      id: 'T5s',
      s: '',
    },
    {
      id: 'T4s',
      s: '',
    },
    {
      id: 'T3s',
      s: '',
    },
    {
      id: 'T2s',
      s: '',
    },
    {
      id: 'A9o',
      s: 'background-image: linear-gradient(to right, var(--clr-R4-initial), var(--clr-R4-initial)),linear-gradient(to right, var(--clr-R3-initial), var(--clr-R3-initial)),linear-gradient(to right, var(--clr-R1-initial), var(--clr-R1-initial)),linear-gradient(to right, var(--clr-C), var(--clr-C)); background-size:13.525000447399501% 100%,32.075001097597834% 100%,60.4083358465395% 100%,100.0000041443895% 100%;',
    },
    {
      id: 'K9o',
      s: 'background-image: linear-gradient(to right, var(--clr-R4-initial), var(--clr-R4-initial)),linear-gradient(to right, var(--clr-R3-initial), var(--clr-R3-initial)),linear-gradient(to right, var(--clr-R1-initial), var(--clr-R1-initial)),linear-gradient(to right, var(--clr-C), var(--clr-C)); background-size:48.341669390591676% 100%,85.90000495314166% 100%,92.04167191249083% 100%,100.00000551032% 100%;',
    },
    {
      id: 'Q9o',
      s: 'background-image: linear-gradient(to right, var(--clr-R4-initial), var(--clr-R4-initial)),linear-gradient(to right, var(--clr-R3-initial), var(--clr-R3-initial)),linear-gradient(to right, var(--clr-R1-initial), var(--clr-R1-initial)),linear-gradient(to right, var(--clr-C), var(--clr-C)); background-size:12.255555888016666% 100%,42.76666823361667% 100%,61.455558240416664% 100%,100.00000480148333% 100%;',
    },
    {
      id: 'J9o',
      s: 'background-image: linear-gradient(to right, var(--clr-R4-initial), var(--clr-R4-initial)),linear-gradient(to right, var(--clr-R3-initial), var(--clr-R3-initial)),linear-gradient(to right, var(--clr-R1-initial), var(--clr-R1-initial)),linear-gradient(to right, var(--clr-C), var(--clr-C)); background-size:29.88333478568333% 100%,56.85833618044167% 100%,76.47500348588333% 100%,100.00000447034166% 100%;',
    },
    {
      id: 'T9o',
      s: 'background-image: linear-gradient(to right, var(--clr-R4-initial), var(--clr-R4-initial)),linear-gradient(to right, var(--clr-R3-initial), var(--clr-R3-initial)),linear-gradient(to right, var(--clr-R1-initial), var(--clr-R1-initial)),linear-gradient(to right, var(--clr-C), var(--clr-C)); background-size:8.444444711014446% 100%,21.55555623273667% 100%,52.622223935192224% 100%,100.00000368389223% 100%;',
    },
    {
      id: '99',
      s: 'background-image: linear-gradient(to right, var(--clr-R4-initial), var(--clr-R4-initial)),linear-gradient(to right, var(--clr-R1-initial), var(--clr-R1-initial)),linear-gradient(to right, var(--clr-C), var(--clr-C)); background-size:0.050000002375000005% 100%,24.066667408125% 100%,100.00000461972499% 100%;',
    },
    {
      id: '98s',
      s: 'background-image: linear-gradient(to right, var(--clr-R4-initial), var(--clr-R4-initial)),linear-gradient(to right, var(--clr-R3-initial), var(--clr-R3-initial)),linear-gradient(to right, var(--clr-R1-initial), var(--clr-R1-initial)),linear-gradient(to right, var(--clr-C), var(--clr-C)); background-size:40.60000255705% 100%,66.5250040591% 100%,90.55000543595% 100%,100.00000604779974% 100%;',
    },
    {
      id: '97s',
      s: 'background-image: linear-gradient(to right, var(--clr-R4-initial), var(--clr-R4-initial)),linear-gradient(to right, var(--clr-R3-initial), var(--clr-R3-initial)),linear-gradient(to right, var(--clr-R1-initial), var(--clr-R1-initial)),linear-gradient(to right, var(--clr-C), var(--clr-C)); background-size:17.633334267899336% 100%,24.566667744299338% 100%,43.866668362199334% 100%,100.00000369426601% 100%;',
    },
    {
      id: '96s',
      s: 'background-image: linear-gradient(to right, var(--clr-R4-initial), var(--clr-R4-initial)),linear-gradient(to right, var(--clr-R3-initial), var(--clr-R3-initial)),linear-gradient(to right, var(--clr-R1-initial), var(--clr-R1-initial)),linear-gradient(to right, var(--clr-C), var(--clr-C)); background-size:30.225001275525% 100%,70.3250028193% 100%,78.47500331699999% 100%,100.00000484286% 100%;',
    },
    {
      id: '95s',
      s: '',
    },
    {
      id: '94s',
      s: '',
    },
    {
      id: '93s',
      s: '',
    },
    {
      id: '92s',
      s: '',
    },
    {
      id: 'A8o',
      s: 'background-image: linear-gradient(to right, var(--clr-R4-initial), var(--clr-R4-initial)),linear-gradient(to right, var(--clr-R3-initial), var(--clr-R3-initial)),linear-gradient(to right, var(--clr-R1-initial), var(--clr-R1-initial)),linear-gradient(to right, var(--clr-C), var(--clr-C)); background-size:14.15000074388433% 100%,28.025001411656% 100%,54.975002631561% 100%,100.00000484289433% 100%;',
    },
    {
      id: 'K8o',
      s: 'background-image: linear-gradient(to right, var(--clr-R4-initial), var(--clr-R4-initial)),linear-gradient(to right, var(--clr-R3-initial), var(--clr-R3-initial)),linear-gradient(to right, var(--clr-R1-initial), var(--clr-R1-initial)),linear-gradient(to right, var(--clr-C), var(--clr-C)); background-size:17.633334128190338% 100%,38.08333543129868% 100%,65.60000334868869% 100%,100.00000451694537% 100%;',
    },
    {
      id: 'Q8o',
      s: '',
    },
    {
      id: 'J8o',
      s: 'background-image: linear-gradient(to right, var(--clr-R4-initial), var(--clr-R4-initial)),linear-gradient(to right, var(--clr-R3-initial), var(--clr-R3-initial)),linear-gradient(to right, var(--clr-R1-initial), var(--clr-R1-initial)),linear-gradient(to right, var(--clr-C), var(--clr-C)); background-size:26.775001113624995% 100%,54.30000262958333% 100%,65.183336349855% 100%,100.00000428413% 100%;',
    },
    {
      id: 'T8o',
      s: 'background-image: linear-gradient(to right, var(--clr-R4-initial), var(--clr-R4-initial)),linear-gradient(to right, var(--clr-R3-initial), var(--clr-R3-initial)),linear-gradient(to right, var(--clr-R1-initial), var(--clr-R1-initial)),linear-gradient(to right, var(--clr-C), var(--clr-C)); background-size:14.833333922768887% 100%,21.044445327597774% 100%,51.10000169112% 100%,100.00000393226443% 100%;',
    },
    {
      id: '98o',
      s: 'background-image: linear-gradient(to right, var(--clr-R4-initial), var(--clr-R4-initial)),linear-gradient(to right, var(--clr-R3-initial), var(--clr-R3-initial)),linear-gradient(to right, var(--clr-R1-initial), var(--clr-R1-initial)),linear-gradient(to right, var(--clr-C), var(--clr-C)); background-size:39.608335495% 100%,68.57500349481666% 100%,81.81667060900833% 100%,100.00000465660833% 100%;',
    },
    {
      id: '88',
      s: 'background-image: linear-gradient(to right, var(--clr-R1-initial), var(--clr-R1-initial)),linear-gradient(to right, var(--clr-C), var(--clr-C)); background-size:16.116667290516666% 100%,100.00000248351665% 100%;',
    },
    {
      id: '87s',
      s: 'background-image: linear-gradient(to right, var(--clr-R4-initial), var(--clr-R4-initial)),linear-gradient(to right, var(--clr-R3-initial), var(--clr-R3-initial)),linear-gradient(to right, var(--clr-R1-initial), var(--clr-R1-initial)),linear-gradient(to right, var(--clr-C), var(--clr-C)); background-size:18.600001682826665% 100%,26.90000211199333% 100%,39.50000256299% 100%,100.00000397362334% 100%;',
    },
    {
      id: '86s',
      s: 'background-image: linear-gradient(to right, var(--clr-R4-initial), var(--clr-R4-initial)),linear-gradient(to right, var(--clr-R3-initial), var(--clr-R3-initial)),linear-gradient(to right, var(--clr-R1-initial), var(--clr-R1-initial)),linear-gradient(to right, var(--clr-C), var(--clr-C)); background-size:32.82500132915% 100%,62.850002199375% 100%,75.00000298019499% 100%,100.00000474389473% 100%;',
    },
    {
      id: '85s',
      s: 'background-image: linear-gradient(to right, var(--clr-R4-initial), var(--clr-R4-initial)),linear-gradient(to right, var(--clr-R3-initial), var(--clr-R3-initial)),linear-gradient(to right, var(--clr-R1-initial), var(--clr-R1-initial)),linear-gradient(to right, var(--clr-X), var(--clr-X)); background-size:1.1500000255165% 100%,4.8000002861985% 100%,42.8000024170735% 100%,100.00000508734851% 100%;',
    },
    {
      id: '84s',
      s: '',
    },
    {
      id: '83s',
      s: '',
    },
    {
      id: '82s',
      s: '',
    },
    {
      id: 'A7o',
      s: 'background-image: linear-gradient(to right, var(--clr-R4-initial), var(--clr-R4-initial)),linear-gradient(to right, var(--clr-R3-initial), var(--clr-R3-initial)),linear-gradient(to right, var(--clr-R1-initial), var(--clr-R1-initial)),linear-gradient(to right, var(--clr-F), var(--clr-F)); background-size:16.055556552272222% 100%,23.233334758936667% 100%,44.38889146421444% 100%,100.00000583372554% 100%;',
    },
    {
      id: 'K7o',
      s: '',
    },
    {
      id: 'Q7o',
      s: '',
    },
    {
      id: 'J7o',
      s: '',
    },
    {
      id: 'T7o',
      s: '',
    },
    {
      id: '97o',
      s: '',
    },
    {
      id: '87o',
      s: 'background-image: linear-gradient(to right, var(--clr-R4-initial), var(--clr-R4-initial)),linear-gradient(to right, var(--clr-R3-initial), var(--clr-R3-initial)),linear-gradient(to right, var(--clr-R1-initial), var(--clr-R1-initial)),linear-gradient(to right, var(--clr-F), var(--clr-F)); background-size:49.866667824478895% 100%,50.38889007538645% 100%,52.65555684453867% 100%,100.00000390120401% 100%;',
    },
    {
      id: '77',
      s: 'background-image: linear-gradient(to right, var(--clr-R4-initial), var(--clr-R4-initial)),linear-gradient(to right, var(--clr-R3-initial), var(--clr-R3-initial)),linear-gradient(to right, var(--clr-R1-initial), var(--clr-R1-initial)); background-size:66.26666784283334% 100%,89.36666958033334% 100%,100.00000327513% 100%;',
    },
    {
      id: '76s',
      s: 'background-image: linear-gradient(to right, var(--clr-R4-initial), var(--clr-R4-initial)),linear-gradient(to right, var(--clr-R3-initial), var(--clr-R3-initial)),linear-gradient(to right, var(--clr-R1-initial), var(--clr-R1-initial)),linear-gradient(to right, var(--clr-F), var(--clr-F)); background-size:8.600000385193335% 100%,20.066667441293333% 100%,51.966670000293334% 100%,100.00000580526% 100%;',
    },
    {
      id: '75s',
      s: 'background-image: linear-gradient(to right, var(--clr-R4-initial), var(--clr-R4-initial)),linear-gradient(to right, var(--clr-R3-initial), var(--clr-R3-initial)),linear-gradient(to right, var(--clr-R1-initial), var(--clr-R1-initial)),linear-gradient(to right, var(--clr-F), var(--clr-F)); background-size:15.200001249699998% 100%,24.7000021239% 100%,52.8000039359% 100%,100.00000447038333% 100%;',
    },
    {
      id: '74s',
      s: '',
    },
    {
      id: '73s',
      s: '',
    },
    {
      id: '72s',
      s: '',
    },
    {
      id: 'A6o',
      s: 'background-image: linear-gradient(to right, var(--clr-R4-initial), var(--clr-R4-initial)),linear-gradient(to right, var(--clr-R3-initial), var(--clr-R3-initial)),linear-gradient(to right, var(--clr-R1-initial), var(--clr-R1-initial)),linear-gradient(to right, var(--clr-F), var(--clr-F)); background-size:19.350000983090833% 100%,36.416668506929994% 100%,64.04166972882166% 100%,100.00000403569666% 100%;',
    },
    {
      id: 'K6o',
      s: '',
    },
    {
      id: 'Q6o',
      s: '',
    },
    {
      id: 'J6o',
      s: '',
    },
    {
      id: 'T6o',
      s: '',
    },
    {
      id: '96o',
      s: '',
    },
    {
      id: '86o',
      s: '',
    },
    {
      id: '76o',
      s: '',
    },
    {
      id: '66',
      s: 'background-image: linear-gradient(to right, var(--clr-R4-initial), var(--clr-R4-initial)),linear-gradient(to right, var(--clr-R1-initial), var(--clr-R1-initial)),linear-gradient(to right, var(--clr-F), var(--clr-F)); background-size:0.150000001304% 100%,10.966667346653669% 100%,100.00000378737033% 100%;',
    },
    {
      id: '65s',
      s: 'background-image: linear-gradient(to right, var(--clr-R4-initial), var(--clr-R4-initial)),linear-gradient(to right, var(--clr-R3-initial), var(--clr-R3-initial)),linear-gradient(to right, var(--clr-R1-initial), var(--clr-R1-initial)),linear-gradient(to right, var(--clr-F), var(--clr-F)); background-size:11.97500005365% 100%,26.475000754025% 100%,57.250002771625006% 100%,100.00000521545002% 100%;',
    },
    {
      id: '64s',
      s: 'background-image: linear-gradient(to right, var(--clr-R4-initial), var(--clr-R4-initial)),linear-gradient(to right, var(--clr-R3-initial), var(--clr-R3-initial)),linear-gradient(to right, var(--clr-R1-initial), var(--clr-R1-initial)),linear-gradient(to right, var(--clr-F), var(--clr-F)); background-size:6.5500001306549995% 100%,18.7750008189775% 100%,47.4500019335525% 100%,100.0000056111775% 100%;',
    },
    {
      id: '63s',
      s: '',
    },
    {
      id: '62s',
      s: '',
    },
    {
      id: 'A5o',
      s: 'background-image: linear-gradient(to right, var(--clr-R4-initial), var(--clr-R4-initial)),linear-gradient(to right, var(--clr-R3-initial), var(--clr-R3-initial)),linear-gradient(to right, var(--clr-R1-initial), var(--clr-R1-initial)),linear-gradient(to right, var(--clr-F), var(--clr-F)); background-size:31.158334792905006% 100%,55.40000240629668% 100%,67.91666966552918% 100%,100.00000475751168% 100%;',
    },
    {
      id: 'K5o',
      s: '',
    },
    {
      id: 'Q5o',
      s: '',
    },
    {
      id: 'J5o',
      s: '',
    },
    {
      id: 'T5o',
      s: '',
    },
    {
      id: '95o',
      s: '',
    },
    {
      id: '85o',
      s: '',
    },
    {
      id: '75o',
      s: '',
    },
    {
      id: '65o',
      s: '',
    },
    {
      id: '55',
      s: 'background-image: linear-gradient(to right, var(--clr-R4-initial), var(--clr-R4-initial)),linear-gradient(to right, var(--clr-R3-initial), var(--clr-R3-initial)),linear-gradient(to right, var(--clr-R1-initial), var(--clr-R1-initial)),linear-gradient(to right, var(--clr-F), var(--clr-F)); background-size:6.783333851489999% 100%,11.016667319938332% 100%,17.9000007881385% 100%,100.0000047458885% 100%;',
    },
    {
      id: '54s',
      s: 'background-image: linear-gradient(to right, var(--clr-R4-initial), var(--clr-R4-initial)),linear-gradient(to right, var(--clr-R3-initial), var(--clr-R3-initial)),linear-gradient(to right, var(--clr-R1-initial), var(--clr-R1-initial)),linear-gradient(to right, var(--clr-F), var(--clr-F)); background-size:23.425001278475% 100%,44.17500235135% 100%,71.000003814625% 100%,100.000005774125% 100%;',
    },
    {
      id: '53s',
      s: '',
    },
    {
      id: '52s',
      s: '',
    },
    {
      id: 'A4o',
      s: 'background-image: linear-gradient(to right, var(--clr-R4-initial), var(--clr-R4-initial)),linear-gradient(to right, var(--clr-R3-initial), var(--clr-R3-initial)),linear-gradient(to right, var(--clr-R1-initial), var(--clr-R1-initial)),linear-gradient(to right, var(--clr-F), var(--clr-F)); background-size:31.416668494533333% 100%,61.15833669900001% 100%,76.05000405261501% 100%,100.00000524643751% 100%;',
    },
    {
      id: 'K4o',
      s: '',
    },
    {
      id: 'Q4o',
      s: '',
    },
    {
      id: 'J4o',
      s: '',
    },
    {
      id: 'T4o',
      s: '',
    },
    {
      id: '94o',
      s: '',
    },
    {
      id: '84o',
      s: '',
    },
    {
      id: '74o',
      s: '',
    },
    {
      id: '64o',
      s: '',
    },
    {
      id: '54o',
      s: '',
    },
    {
      id: '44',
      s: 'background-image: linear-gradient(to right, var(--clr-R4-initial), var(--clr-R4-initial)),linear-gradient(to right, var(--clr-R3-initial), var(--clr-R3-initial)),linear-gradient(to right, var(--clr-R1-initial), var(--clr-R1-initial)),linear-gradient(to right, var(--clr-F), var(--clr-F)); background-size:12.866667252591665% 100%,24.116667866507832% 100%,30.78333503607783% 100%,100.0000056286945% 100%;',
    },
    {
      id: '43s',
      s: '',
    },
    {
      id: '42s',
      s: '',
    },
    {
      id: 'A3o',
      s: '',
    },
    {
      id: 'K3o',
      s: '',
    },
    {
      id: 'Q3o',
      s: '',
    },
    {
      id: 'J3o',
      s: '',
    },
    {
      id: 'T3o',
      s: '',
    },
    {
      id: '93o',
      s: '',
    },
    {
      id: '83o',
      s: '',
    },
    {
      id: '73o',
      s: '',
    },
    {
      id: '63o',
      s: '',
    },
    {
      id: '53o',
      s: '',
    },
    {
      id: '43o',
      s: '',
    },
    {
      id: '33',
      s: 'background-image: linear-gradient(to right, var(--clr-R4-initial), var(--clr-R4-initial)),linear-gradient(to right, var(--clr-R3-initial), var(--clr-R3-initial)),linear-gradient(to right, var(--clr-R1-initial), var(--clr-R1-initial)),linear-gradient(to right, var(--clr-F), var(--clr-F)); background-size:27.016667773326663% 100%,48.05000188450667% 100%,53.116668822871674% 100%,100.00000378738834% 100%;',
    },
    {
      id: '32s',
      s: '',
    },
    {
      id: 'A2o',
      s: '',
    },
    {
      id: 'K2o',
      s: '',
    },
    {
      id: 'Q2o',
      s: '',
    },
    {
      id: 'J2o',
      s: '',
    },
    {
      id: 'T2o',
      s: '',
    },
    {
      id: '92o',
      s: '',
    },
    {
      id: '82o',
      s: '',
    },
    {
      id: '72o',
      s: '',
    },
    {
      id: '62o',
      s: '',
    },
    {
      id: '52o',
      s: '',
    },
    {
      id: '42o',
      s: '',
    },
    {
      id: '32o',
      s: '',
    },
    {
      id: '22',
      s: 'background-image: linear-gradient(to right, var(--clr-R4-initial), var(--clr-R4-initial)),linear-gradient(to right, var(--clr-R3-initial), var(--clr-R3-initial)),linear-gradient(to right, var(--clr-R1-initial), var(--clr-R1-initial)),linear-gradient(to right, var(--clr-X), var(--clr-X)); background-size:29.50000166891667% 100%,58.683336029433335% 100%,65.31666964290834% 100%,100.000004221975% 100%;',
    },
  ]
}

export { getRangeTableMock }
